/**
 * AppStatusPill — пилюля статуса заявки (точка + текст на мягком фоне),
 * в стиле StatusPill клиентов. Явные hex — семантическая палитра статусов
 * (та же, что в «Клиентах»), не токены темы.
 */

import type {ApplicationStatus} from '@services/applications';
import {cn} from '@lib/utils';

import {STATUS_LABEL} from '../Applications.utils';

const STYLE: Record<ApplicationStatus, {className: string; dot: string}> = {
  pending: {className: 'bg-[#FBF3E4] text-[#B07908]', dot: 'bg-[#B07908]'},
  reviewed: {className: 'bg-[#E6F4EC] text-[#1B7A54]', dot: 'bg-[#1B7A54]'},
  rejected: {className: 'bg-[#F0F1F4] text-[#7C808A]', dot: 'bg-[#7C808A]'},
};

type Props = {status: ApplicationStatus; className?: string};

export const AppStatusPill = ({status, className}: Props) => (
  <span
    className={cn(
      'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-[9px] py-[3px] text-[12.5px] font-semibold',
      STYLE[status].className,
      className,
    )}
  >
    <span className={cn('size-1.5 rounded-full', STYLE[status].dot)} />
    {STATUS_LABEL[status]}
  </span>
);
